export const LAYOUT_PRESET = "compact";
export const ROW_MIN_HEIGHT_REM = 3.5;
export const ROW_PADDING_REM = 1;
/** Largura mínima de cada mês (rem) na revisão: mais estreita que a do Gantt principal. */
export const MONTH_MIN_WIDTH = "3.5rem";
